import React from "react";
import { Image } from "react-bootstrap";
import SubscribeNewsletter from "../../pages/Home/SubscribeNewsletter";

export default function AboutUsScreen() {
  return (
    <>
      <div className="creatyea-padding about-us-section">
        <div className="row">
          <div className="col-lg-6 padding-inline-35px d-flex flex-column justify-content-center">
            <h2>Who are we?</h2>
            <p>
              We at Creatyea specialize in providing a comprehensive platform
              for electronics enthusiasts, hobbyists, and professionals. We are
              a trusted partner in the journey of product design and component
              purchase, catering to a diverse range of customers since 2018.
              With our extensive product catalog, user-friendly interface, and
              unwavering commitment to customer satisfaction, we strive to be
              the go-to destination for all electronics-related needs.
            </p>
            <div className="vision-section">
              <div className="vision">
                <h2>Our Vision</h2>
                <p>
                  We strive to be the ultimate destination for product design
                  and component purchase, offering a comprehensive platform that
                  combines cutting-edge technology, extensive resources, and
                  exceptional customer service. At Creatyea, our mission is to
                  be more than just a website; we aspire to be a catalyst for
                  innovation, a source of inspiration, and a platform that
                  empowers individuals to transform their electronic dreams into
                  reality. Together, let's unleash the power of creativity and
                  make a meaningful impact on the world of electronics.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 padding-inline-35px d-flex flex-column justify-content-center">
            <Image
              src="./img/teamwork.png"
              className="img-fluid about-us-img"
              alt="Who we are"
            />
          </div>
        </div>
      </div>
      <div className="creatyea-padding about-us-section">
        <div className="row">
          <div className="col-lg-6 padding-inline-35px d-flex flex-column justify-content-center">
            <Image
              src="./img/earth.png"
              className="img-fluid about-us-img"
              alt="Global"
            />
          </div>
          <div className="col-lg-6 padding-inline-35px d-flex flex-column justify-content-center">
            <h2 className="decorated-title">Our Services</h2>
            <p>
              At Creatyea, we pride ourselves on offering a comprehensive
              solution to your electronic component needs. With our extensive
              product catalogue over 2.5 million unique components, you'll find
              everything you require in one place, streamlining your sourcing
              journey.
            </p>
            <br />
            <p>
              We offer engineering services for your electronic product in the
              areas of PCB design, DFM Analysis, BOM optimization and price
              reduction, Reverse Engineering, Mechanical Design, Visual Product
              Design, Firmware development and physical product prototyping and
              mass manufacturing. <a href="/contact_us">Drop us a mail</a> to
              discuss.
            </p>
          </div>
        </div>
      </div>
      <div className="creatyea-padding about-us-section">
        <div className="row">
          <div className="col-lg-6 padding-inline-35px d-flex flex-column justify-content-center">
            <h2 className="decorated-title">Research &amp; Design Support</h2>
            <p>
              From startups to global enterprises, we assist companies in
              designing, prototyping, and manufacturing their products. With an
              unparalleled array of components, development kits and and
              experienced engineering tea, we can be an essential component of
              your product research and design process.
            </p>
            <br />
            <p>
              Our extensive catalog of products and components are updated every
              day. Whether you're looking for the latest components from leading
              global brands, or innovative technologies from up-and-coming
              manufacturers, Creatyea can help you to find it, ship it in no
              time. If you can't find a part of your choice.{" "}
              <a href="/products/get_quote">Request a quote</a> and we will find
              it for you.
            </p>
          </div>
          <div className="col-lg-6 padding-inline-35px d-flex flex-column justify-content-center">
            <Image
              src="./img/research_design.png"
              className="img-fluid about-us-img"
              alt="Research and Design"
            />
          </div>
        </div>
      </div>
      <div className="creatyea-padding about-us-section">
        <div className="row">
          <div className="col-lg-6 padding-inline-35px d-flex flex-column justify-content-center">
            <Image
              src="./img/design_right.png"
              className="img-fluid about-us-img"
              alt="Design right the first time"
            />
          </div>
          <div className="col-lg-6 padding-inline-35px d-flex flex-column justify-content-center">
            <h2 className="decorated-title">Design Right the First Time</h2>
            <p>
              We reliably deliver the high-quality parts that our customers
              need. Find thousands of electronic parts using partial part
              numbers or description searches. With an Interactive Parametric
              Search, find the perfect component to fit your ends by filtering.
              We can help avoid unplanned redesign and manage obsolescence risk
              parts before manufacturing your first PCBs.
            </p>
            <br />
            <p>
              Gain up-to date information on delays, shortages and global market
              shifts to mitigate risks within your supply chain. Keep a track of
              our stocks to get a pulse of the global availability of stocks.
            </p>
          </div>
        </div>
      </div>
      <SubscribeNewsletter />
    </>
  );
}
